export default __webpack_public_path__ + "static/media/bwin_black.62f2d995.png";